export function formatScore(score: number, locale = "en-US"): string {
  return Math.max(0, Math.floor(score)).toLocaleString(locale);
}

export function percentForLevelProgress(progress: number): string {
  return `${Math.max(0, Math.min(100, progress * 10))}%`;
}
